import React from 'react';
import { useTranslation } from 'react-i18next';

import { LinkVariant } from 'api/contentful/contentTypes.cloverdotcom';
import { StructuredModal, StructuredModalState } from 'components/StructuredModal/StructuredModal';
import type { IProductModel } from '../Cart/models';
import { useToOxfordComma } from 'hooks/useToOxfordComma';

export interface IConfirmProductRemovalModalProps {
  removedProduct: IProductModel;
  onConfirm: (product: IProductModel) => void;
  modalState: StructuredModalState;
  products: IProductModel[];
}

export const ConfirmProductRemovalModal: React.FC<IConfirmProductRemovalModalProps> = ({
  removedProduct,
  onConfirm,
  modalState,
  products,
}) => {
  const { t } = useTranslation();

  const accessories = useToOxfordComma(products.map(p => `**${p.name}**`));
  const stringKeyToUse = products.length === 1 ? 'description-singular' : 'description-plural';

  return (
    <StructuredModal
      modalState={modalState}
      title={t('confirm-remove-modal.title')}
      description={t(`confirm-remove-modal.${stringKeyToUse}`, {
        systemName: removedProduct.name,
        accessories,
      })}
      actions={[
        {
          label: t('cancel'),
          variant: LinkVariant.SECONDARY,
          isCloseButton: true,
        },
        {
          label: t('confirm'),
          variant: LinkVariant.PRIMARY,
          action: () => onConfirm(removedProduct),
        },
      ]}
    />
  );
};

ConfirmProductRemovalModal.displayName = 'ConfirmProductRemovalModal';
